// extracted by mini-css-extract-plugin
export default {"editable":"mkclq","editableMultiline":"E7ixN","heading1":"Lm3ab","heading2":"LIB13","heading3":"WLZFe","text":"vxUmJ","editableReadOnly":"YKZeT"};